import React from 'react';
import styled, { keyframes } from 'styled-components';
import { CardContent } from '../components/CardContent.tsx';

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 40px;

   @media (max-width: 768px) {
    padding: 0;
    gap: 24px;
        padding-bottom: 15%
  }

`;

const InfoCardsWrapper = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
      @media (max-width: 768px) {
    gap: 8px;
    
  }

`;

const InfoCard = styled.div`
  flex: 1 1 200px;
  background-color: var(--primary-color);
  color: #fff;
  border-radius: 12px;
  padding: 24px;
  font-family: 'Onest', sans-serif;
  display: flex;
  flex-direction: column;
  gap: 12px;
    @media (max-width: 768px) {
      flex: 1 1 calc(50% - 60px); /* максимум два столбца с учетом gap */
    padding: 16px;
    gap: 8px;

  }


`;

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const Loader = styled.div`

  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top: 3px solid white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: ${spin} 0.8s linear infinite;
`;

interface DashboardPageProps {
  data: any;
  children?: React.ReactNode;
  loading: boolean;
}

export const DashboardPage: React.FC<DashboardPageProps> = ({ data, children, loading }) => {
  const renderValue = (value: any, prefix?: string) =>
    loading ? <Loader /> : `${prefix || ''}${value}`;

  return (
    <PageWrapper>
      <InfoCardsWrapper>
        <InfoCard>
          <CardContent title="Пользователи" value={renderValue(data.users)} subValue={loading? null : data.newUsers } />
        </InfoCard>
        <InfoCard>
          <CardContent title="Всего выплачено" value={renderValue(data.paid, '$')} />
        </InfoCard>
        <InfoCard>
          <CardContent title="Ср. выживаемость" value={renderValue(data.survivability)} />
        </InfoCard>
        <InfoCard>
          <CardContent title="Ср. цена инвайта" value={renderValue(data.avgInvite)} />
        </InfoCard>
        <InfoCard>
          <CardContent title="Ср. себестоимость" value={renderValue(data.avgPrice, '$')} />
        </InfoCard>
      </InfoCardsWrapper>

      {children}
    </PageWrapper>
  );
};
